export const filterStyledProps = (list: string[]) => (prop: string) => !list.includes(prop);
